import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';
import * as Map from 'immutable';
import qs from 'qs';
import HTTP from '../../script/service';
import Util from '../../script/util';
import WEBIM from '../../store/WebNim';
import { message, Modal } from 'antd';
import {
  AndroidFilled,
  AppleFilled,
  IeOutlined,
  CloseSquareFilled,
} from '@ant-design/icons';
import {
  _new_nim_window,
  _new_room_window,
  _dssp_send_click,
  _h5_link_to,
  _change_ds_modal,
  _dssp_show_event,
} from '../../store/Action';
import IframeModal from '../iframModal/IframModal';
import store from '../../store/store';
import BannerCarousel from '../bannerCarousel';
import './index.scss';

const getBracketsMsg = function (msg) {
  let fitMsg = msg.match(/\{[^}]+\}/);
  if (fitMsg[0]) {
    return fitMsg[0];
  }
  return '';
};
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'message',
      follow_param: {
        uid: null,
        page: 0,
        size: 20,
      },
      fans_param: {
        uid: null,
        page: 0,
        size: 20,
      },
      recommend_param: {
        uid: null,
        page: 0,
        size: 20,
      },
      fans_data: {},
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.newRemarkName);
    const props2 = Map.fromJS(this.props.base.newRemarkName);
    if (this.props.base.newRemarkName && !Map.is(props1, props2)) {
      const { type, fans, follows } = this.state;
      if (type == 'fans' || type == 'follow') {
        const uid = Util.$analyToUid(WEBIM.to.account);
        let newData = [];
        if (type == 'fans') {
          newData = [...fans];
        } else if (type == 'follow') {
          newData = [...follows];
        }
        const find = newData.find((e) => e.uid == uid);
        if (find) find.remarkName = this.props.base.newRemarkName;
        this.setState({ fans: newData });
      }
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }
  //初始化
  componentDidMount() {
    WEBIM.onConfigFn('_FRIEND_SESSION_UPDATE', () => {
      this.forceUpdate();
    });

    this.getLangDict();

    this.getSessionBanner();
  }
  //获取语言字典
  getLangDict = () => {
    const { langDicts } = this.props.base;
    if (!langDicts) {
      HTTP._get_lang_dicts({}).then((res) => {
        if (res && res.code === 200) {
          store.dispatch({
            type: 'change_lang_dicts',
            data: { langDicts: res.data },
          });
        }
      });
    }
  };
  //切换类型
  changeType = (type) => {
    if (this.state.type !== type) {
      this.loading = false;
      this.setState({ type: type }, () => {
        this.srcollElement && this.srcollElement.scrollToTop();
        if (this.state.type == 'recommend') {
          this.getrecommend(true);
        } else if (this.state.type == 'follow') {
          this.getfollow(true);
        } else if (this.state.type == 'fans') {
          this.getfans(true);
          this.focusRead();
        }
      });
    }

    let tab_name = '';
    let sub_tab_name = '';
    let scene_name = '';
    if (type === 'message') {
      tab_name = '消息列表';
      scene_name = '消息列表';
    } else if (type === 'follow') {
      tab_name = '粉丝关注';
      sub_tab_name = '关注列表';
      scene_name = '关注和粉丝';
    } else if (type === 'fans') {
      tab_name = '粉丝关注';
      sub_tab_name = '粉丝列表';
      scene_name = '关注和粉丝';
    }
    if (tab_name) {
      // 上报
      _dssp_show_event({
        page_name: '消息',
        tab_name: `${tab_name}`,
        sub_tab_name: `${sub_tab_name}`,
        scene_category: `消息`,
        scene_name: `${scene_name}`,
      });
    }
  };
  //推荐
  getrecommend = (reset) => {
    if (this.loading) return false;
    let { recommend_param, recommends } = this.state;
    const { uid } = this.props.base;
    if (reset) {
      recommend_param.uid = uid;
      recommend_param.page = 0;
      recommend_param.size = 20;
      recommend_param.last = false;
      recommends = [];
    }
    if (recommend_param.last) return false;
    this.loading = true;
    recommend_param.page += 1;
    HTTP._get_my_recommend(recommend_param).then((res) => {
      if (!recommends) recommends = [];
      if (res.code == 200 && res.data && res.data.content) {
        recommends = recommends.concat(res.data.content);
        recommend_param.last = res.data.last;
      } else {
        recommend_param.last = true;
      }
      this.setState({
        recommend_param: { ...recommend_param },
        recommends: recommends,
      });
      this.loading = false;
    });
  };
  //我的关注
  getfollow = (reset) => {
    if (this.loading) return false;
    let { follow_param, follows } = this.state;
    const { uid } = this.props.base;
    if (reset) {
      follow_param.uid = uid;
      follow_param.page = 0;
      follow_param.size = 20;
      follow_param.last = false;
      follows = [];
    }
    if (follow_param.last) return false;
    this.loading = true;
    follow_param.page += 1;
    HTTP._get_my_follow(follow_param).then((res) => {
      if (!follows) follows = [];
      if (res.code == 200 && res.data && res.data.content) {
        follows = follows.concat(res.data.content);
        follow_param.last = res.data.last;
      } else {
        follow_param.last = true;
      }
      this.setState({
        follow_param: { ...follow_param },
        follows: follows,
      });
      this.loading = false;
    });
  };
  //获取粉丝
  getfans = (reset) => {
    if (this.loading) return false;
    let { fans_param, fans } = this.state;
    const { uid } = this.props.base;
    if (reset) {
      fans_param.uid = uid;
      fans_param.page = 0;
      fans_param.size = 20;
      fans_param.last = false;
      fans = [];
    }
    if (fans_param.last) return false;
    this.loading = true;
    fans_param.page += 1;
    HTTP._get_my_fans(fans_param).then((res) => {
      if (!fans) fans = [];
      if (res.code == 200 && res.data && res.data.content) {
        fans = fans.concat(res.data.content);
        fans_param.last = res.data.last;
      } else {
        fans_param.last = true;
      }
      this.setState({
        fans_param: { ...fans_param },
        fans: fans,
      });
      this.loading = false;
    });
  };
  //粉丝已读
  focusRead = () => {
    let { content } = this.state.fans_data;
    const { uid } = this.props.base;
    if (content && content.length > 0 && content[0].readed == 0) {
      HTTP._focus_read({
        uid: uid,
        otherUid: -1,
      }).then((res) => {
        if (res.code == 200) {
          content[0].readed = 1;
          this.setState({
            fans_data: { ...this.state.fans_data },
          });
        }
      });
    }
  };
  //滚动检测
  handleScroll = (e) => {
    if (this.loading) return false;
    if (e.scrollHeight - (e.scrollTop + e.clientHeight) < 100) {
      if (this.state.type == 'recommend') {
        this.getrecommend(false);
      } else if (this.state.type == 'follow') {
        this.getfollow(false);
      } else if (this.state.type == 'fans') {
        this.getfans(false);
      }
    }
  };
  //打开对话框
  openChat = (item, e) => {
    _new_nim_window({
      id: item.id,
      scene: 'p2p',
      account: item.to,
      origin: 'msgList',
    });
    e.stopPropagation && e.stopPropagation();
  };
  //打开对话框
  openChatUid = (item, e) => {
    _new_nim_window({
      id: `p2p-${Util.$analyToAccount(item.uid)}`,
      scene: 'p2p',
      account: Util.$analyToAccount(item.uid),
    });
    e.stopPropagation && e.stopPropagation();
  };
  //进入直播间
  inRoom = (item, e) => {
    _new_room_window(
      {
        roomid: item.roomid,
        roomname: item.roomName,
      },
      this.props.history,
      () => {
        this.props.close && this.props.close();
      }
    );
    e.stopPropagation && e.stopPropagation();
  };
  //加关注
  addFollow = (item, e) => {
    if (this.loading) return false;
    this.loading = true;
    HTTP._add_follow_user({
      uid: this.props.base.uid,
      otherUid: item.uid,
    }).then((res) => {
      this.loading = false;
      if (res.code == 200) {
        _dssp_send_click(76, {
          to: item.uid,
        });
        item.ifFriend = 1;
        this.setState({
          follows: { ...this.state.recommends },
        });
      } else {
        message.error(res.message);
      }
    });
    e.stopPropagation && e.stopPropagation();
  };
  //移除异常关注
  delFollow = () => {
    Modal.confirm({
      title: '确认移除异常关注',
      icon: null,
      closable: true,
      content: (
        <span>
          确认移除您关注列表中的全部异常关注吗，移除后不可撤销哦，关注数量也会相应减少
        </span>
      ),
      className: 'daidai-confirm-style',
      cancelText: '取消',
      okText: '确认移除',
      centered: true,
      onOk: () => {
        HTTP._del_error_follow().then((res) => {
          if (res.code == 200) {
            this.getfollow(true);
            message.success('移除成功');
          } else {
            message.error(res.message);
          }
        });
      },
    });
  };
  //移除异常粉丝
  delFans = () => {
    Modal.confirm({
      title: '确认移除异常粉丝',
      icon: null,
      closable: true,
      content: (
        <span>
          确认移除您粉丝列表中的全部异常粉丝吗，移除后不可撤销哦，粉丝数量也会相应减少
        </span>
      ),
      className: 'daidai-confirm-style',
      cancelText: '取消',
      okText: '确认移除',
      centered: true,
      onOk: () => {
        HTTP._del_error_fans().then((res) => {
          if (res.code == 200) {
            this.getfans(true);
            message.success('移除成功');
          } else {
            message.error(res.message);
          }
        });
      },
    });
  };

  //用户昵称
  renderUserNick = (info) => {
    if (!!info?.custom?.userStatus) {
      return '用户异常';
    } else if (
      info?.fllow?.otherRemarkName &&
      info?.fllow?.otherRemarkName !== ''
    ) {
      return info?.fllow?.otherRemarkName;
    } else {
      return info.nick;
    }
  };
  //用户头像
  renderUserAvatar = (userInfo) => {
    let avatar = userInfo.avatar;
    if (!!userInfo?.custom?.userStatus) {
      avatar = null;
    }
    return <img alt="" src={Util.transImgUrl(avatar, '40x40')} />;
  };
  //最后一条消息
  renderUserLasMessage = (userInfo, lastMsg) => {
    if (!!userInfo?.custom?.userStatus) {
      return '*********';
    }
    return Util.transSessionItem(lastMsg);
  };
  // 亲密关系标签
  renderOtherIntimate = (account) => {
    if (WEBIM?.friends?.length) {
      const find = WEBIM.friends.find((item) => item.account === account);
      let custom = null;
      if (find) {
        custom = Util.isJSONStr(find.serverex)
          ? JSON.parse(find.serverex)
          : null;
      }
      if (custom?.intimateRel?.name) {
        const styles = {};
        styles.color = custom?.intimateRel?.style || '#ccc';
        if (custom?.intimateRel?.labelIcon) {
          styles.backgroundImage = `url(${Util.transImgUrl(custom.intimateRel.labelIcon)})`;
        }
        return (
          <span
            className={Util.classNames('intimate-tag', {
              default: !styles.backgroundImage,
            })}
            style={styles}
          >
            <i>{custom?.intimateRel?.name || ''}</i>
          </span>
        );
      }
    }

    return null;
  };
  //用户状态判断
  isUserStatusInfo = (item, type) => {
    if (!!item && !!item.userStatus) {
      if (type === 'avatar') {
        return null;
      }
      return '*********';
    }
    if (type === 'nick') {
      return item?.remarkName || item?.nickname || '';
    } else if (type === 'sign') {
      return item.sign;
    } else if (type === 'avatar') {
      return item.headPic;
    } else {
      return null;
    }
  };
  getSessionBanner = () => {
    const { sessionBanner } = this.props.base;
    if (sessionBanner && !!sessionBanner.length) return; // 已获取到banner数据，切换无需再次请求
    HTTP._get_home_config({ type: 11 }).then((res) => {
      if (res && res.code === 200) {
        store.dispatch({
          type: 'change_session_banner',
          data: { sessionBanner: res.data },
        });
      }
    });
  };
  //弹窗
  openDil = (item) => {
    _dssp_send_click(1, item);
    _h5_link_to(item.url).then((res) => {
      if (res.params.roomid) {
        _new_room_window(
          {
            roomid: res.params.roomid,
            roomname: res.params.roomname,
          },
          this.props.history
        );
      } else if (res.params.dsid) {
        _change_ds_modal({
          dsid: res.params.dsid,
          jnid: res.params.jnid,
          ehot: false,
        });
      } else {
        this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
      }
    });
  };
  //内容组合
  bindHtml = () => {
    const { webim, rootConfig, langDicts } = this.props.base;
    const { type } = this.state;
    if (!webim.conn) return null;
    function getOnlineStatus(account, ifOnline) {
      if (ifOnline) return 'cc';
      const user = webim.users[account];
      const status = webim.onlineStatus[account];
      if (!user) {
        return 'cc gray';
      }
      if (user?.custom && user?.custom?.sys) {
        return 'cc';
      }
      if (!status || status == '离线') {
        return 'cc gray';
      }
      return 'cc';
    }
    if (type === 'message' && webim.conn) {
      const { sessions, users } = webim;
      if (!sessions) return null;
      let custom = null;
      if (rootConfig.lang != 'zh_CN') {
        sessions.forEach((s, i) => {
          if (
            s.lastMsg &&
            s.lastMsg.custom &&
            typeof s.lastMsg.custom == 'string'
          ) {
            custom = JSON.parse(s.lastMsg.custom);
            s.lastMsg.custom = custom;
          }
          if (custom && custom?.msgBroad && !custom?.action && langDicts) {
            let mBroad = custom.msgBroad;
            while (mBroad.indexOf('{') > -1) {
              let fitKey = getBracketsMsg(mBroad);
              let mlen = fitKey.length;
              let bid = fitKey.substring(1, mlen - 1);
              let langVal =
                langDicts[this.props.base.rootConfig.lang + '-' + bid];
              mBroad = mBroad.replace(fitKey, langVal);
            }
            s.lastMsg.text = mBroad;
          }
        });
      }
      return sessions && sessions.length ? (
        <div className="sesssion-list">
          {sessions.map((item) => {
            if (!item.to) return null;
            const user = users[item.to];
            let { nobleLevel, wealthLevel = '0_0', ifGod } = user.custom || {};
            let wealthLevelArr = wealthLevel.toString().split('_');
            if (wealthLevelArr?.length) {
              wealthLevel = wealthLevelArr[0];
            } else {
              wealthLevel = 0;
            }
            let roleDom = null;
            //系统账号
            if (user?.custom?.sys) roleDom = <i className={`customer sys`} />;
            //全局角色
            if (user?.custom?.roleId)
              roleDom = <i className={`customer role-${user.custom.roleId}`} />;
            if (user?.custom?.toBusinessVipLevel)
              roleDom = (
                <i
                  className={Util.classNames(
                    'customer',
                    `to-bussiness-vip-${user?.custom?.roleId || 0}`
                  )}
                />
              );
            return (
              <span
                className={Util.classNames(
                  'session-item-border',
                  { active: webim.to && webim.to.id === item.id },
                  `role-${user?.custom?.roleId}`
                )}
                key={`uu-${item.id}`}
              >
                <div
                  className="session-item"
                  onClick={this.openChat.bind(this, item)}
                >
                  <div className="cover">
                    {item.unread ? <label>{item.unread}</label> : null}
                    <span className={getOnlineStatus(item.to)}>
                      {this.renderUserAvatar(user, users, item)}
                    </span>
                  </div>
                  <div className="detail">
                    <div className="p1">
                      <label
                        className={Util.classNames({
                          'is-awake': nobleLevel > 2 || wealthLevel > 9,
                        })}
                      >
                        {this.renderUserNick(user)}
                      </label>
                      {roleDom}
                      {this.renderOtherIntimate(item.to)}
                      <label className="time">
                        {Util.transTime(item.updateTime)}
                      </label>
                    </div>
                    <div className="p2">
                      <div
                        className="content"
                        dangerouslySetInnerHTML={{
                          __html: this.renderUserLasMessage(user, item.lastMsg),
                        }}
                      />
                      <span className={`online-state`}>
                        {WEBIM.getDeviceType(item.to) == 'ANDROID' ? (
                          <AndroidFilled />
                        ) : null}
                        {WEBIM.getDeviceType(item.to) == 'IOS' ? (
                          <AppleFilled />
                        ) : null}
                        {WEBIM.getDeviceType(item.to) == 'WEB' ? (
                          <IeOutlined />
                        ) : null}
                      </span>
                    </div>
                  </div>
                  <span
                    className="remove"
                    onClick={(event) => {
                      WEBIM.removeSession(item);
                      event.stopPropagation && event.stopPropagation();
                    }}
                  >
                    <CloseSquareFilled />
                  </span>
                </div>
                {/* 特权展示 */}
                {nobleLevel > 2 || wealthLevel > 9 ? (
                  <div className="awake-icon">{/* 特权 */}</div>
                ) : ifGod ? <div className="god-icon">{/* 大神 */}</div> : null}
              </span>
            );
          })}
        </div>
      ) : (
        <div className="un-data">暂无内容</div>
      );
    } else if (type == 'recommend') {
      const { recommends } = this.state;
      if (!recommends) return null;
      return recommends && recommends.length ? (
        <div className="sesssion-list">
          {recommends.map((item) => {
            return (
              <div
                className={Util.classNames(
                  "session-item-border",
                  {"active": webim.to && webim.to.account === Util.$analyToAccount(item.uid)}
                )}
                key={`mm-${item.uid}`}
              >
                <div
                  className="session-item"
                  onClick={this.openChatUid.bind(this, item)}
                >
                  <span className="cover">
                    <span className="cc">
                      <img
                        alt=""
                        src={Util.transImgUrl(
                          this.isUserStatusInfo(item, 'avatar'),
                          '40x40'
                        )}
                      />
                    </span>
                  </span>
                  {item.userType == 1 ? <div className="god-icon">{/* 大神 */}</div> : null}
                  <div className="detail">
                    <div className="p1">
                      <label>{this.isUserStatusInfo(item, 'nick')}</label>
                      {item.sex == 1 ? (
                        <span className="wman">{item.age}</span>
                      ) : (
                        <span className="man">{item.age}</span>
                      )}
                    </div>
                    <div className="p2">
                      <div className="content">
                        {this.isUserStatusInfo(item, 'sign') ||
                          '他还没有设置签名~'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="un-data">暂无内容</div>
      );
    } else if (type == 'follow') {
      const { follows } = this.state;
      if (!follows) return null;
      return follows && follows.length ? (
        <div className="sesssion-list">
          <div className="sesssion-list">
            {follows.map((item) => {
              return (
                <div
                  className={Util.classNames(
                    "session-item-border",
                    {"active": webim.to && webim.to.account === Util.$analyToAccount(item.uid)}
                  )}
                  key={`kk-${item.uid}`}
                >
                  <div
                    className="session-item"
                    onClick={this.openChatUid.bind(this, item)}
                  >
                    <span className="cover">
                      <span
                        className={getOnlineStatus(item.uid, item.ifOnline)}
                      >
                        <img
                          alt=""
                          src={Util.transImgUrl(
                            this.isUserStatusInfo(item, 'avatar'),
                            '40x40'
                          )}
                        />
                      </span>
                    </span>
                    {item.userType == 1 ? <div className="god-icon">{/* 大神 */}</div> : null}
                    <div className="detail">
                      <div className="p1">
                        <label>{this.isUserStatusInfo(item, 'nick')}</label>
                        {item.sex == 1 ? (
                          <span className="wman">{item.age}</span>
                        ) : (
                          <span className="man">{item.age}</span>
                        )}
                        {item.roomid ? (
                          <span
                            className="roomin"
                            title={item.roomName}
                            onClick={this.inRoom.bind(this, item)}
                          ></span>
                        ) : null}
                      </div>
                      <div className="p2">
                        <div className="content">
                          {this.isUserStatusInfo(item, 'sign') ||
                            '他还没有设置签名~'}
                        </div>
                      </div>
                    </div>
                    {item.ifFriend ? (
                      <div className="is-friend" title="互相关注" />
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="un-data">暂无内容</div>
      );
    } else if (type == 'fans') {
      const { fans } = this.state;
      if (!fans) return null;
      return fans && fans.length ? (
        <div className="sesssion-list">
          <div className="sesssion-list">
            {fans.map((item) => {
              return (
                <div
                  className={Util.classNames(
                    "session-item-border",
                    {"active": webim.to && webim.to.account === Util.$analyToAccount(item.uid)}
                  )}
                  key={`gg-${item.uid}`}
                >
                  <div
                    className="session-item"
                    onClick={this.openChatUid.bind(this, item)}
                  >
                    <span className="cover">
                      <span
                        className={getOnlineStatus(item.uid, item.ifOnline)}
                      >
                        <img
                          alt=""
                          src={Util.transImgUrl(
                            this.isUserStatusInfo(item, 'avatar'),
                            '40x40'
                          )}
                        />
                      </span>
                    </span>
                    {item.userType == 1 ? <div className="god-icon">{/* 大神 */}</div> : null}
                    <div className="detail">
                      <div className="p1">
                        <label>{this.isUserStatusInfo(item, 'nick')}</label>
                        {item.sex == 1 ? (
                          <span className="wman">{item.age}</span>
                        ) : (
                          <span className="man">{item.age}</span>
                        )}
                        {item.roomid ? (
                          <span
                            className="roomin"
                            title={item.roomName}
                            onClick={this.inRoom.bind(this, item)}
                          ></span>
                        ) : null}
                      </div>
                      <div className="p2">
                        <div className="content">
                          {this.isUserStatusInfo(item, 'sign') ||
                            '他还没有设置签名~'}
                        </div>
                      </div>
                    </div>
                    <div className="item-flow">
                      {item.ifFriend ? (
                        <span className="flowed">
                          <label></label>
                          <p>已关注</p>
                        </span>
                      ) : (
                        <label
                          className="flow"
                          onClick={this.addFollow.bind(this, item)}
                        >
                          <label></label>
                          <p>关注</p>
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="un-data">暂无内容</div>
      );
    } else {
      return <div className="un-data">暂无内容</div>;
    }
  };
  render() {
    const { type, fans_data } = this.state;
    const { base, isShowBanner } = this.props;
    const { webim, sessionBanner } = base;
    return (
      <div className="nim-contens">
        {!!isShowBanner && (
          <BannerCarousel
            className="sessions-banner"
            autoplay
            size="300x60"
            data={sessionBanner}
            customClickBanner={this.openDil}
          />
        )}
        <div className="top-types">
          <span
            className={type === 'message' ? 'message active' : 'message'}
            onClick={this.changeType.bind(this, 'message')}
          >
            消息
            {webim && webim.unread ? <i /> : null}
          </span>
          <span
            className={type === 'follow' ? 'follow active' : 'follow'}
            onClick={this.changeType.bind(this, 'follow')}
          >
            关注
          </span>
          <span
            className={type === 'fans' ? 'fans active' : 'fans'}
            onClick={this.changeType.bind(this, 'fans')}
          >
            粉丝
            {fans_data.content && fans_data.content[0].readed == 0 ? (
              <i />
            ) : null}
          </span>
          <span
            className={type === 'recommend' ? 'recommend active' : 'recommend'}
            onClick={this.changeType.bind(this, 'recommend')}
          >
            推荐
          </span>
        </div>
        {type === 'follow' && (
          <div className="nim-del" onClick={this.delFollow}>
            <i className="icon-del"></i>
            <span>移除异常关注</span>
          </div>
        )}
        {type === 'fans' && (
          <div className="nim-del" onClick={this.delFans}>
            <i className="icon-del"></i>
            <span>移除异常粉丝</span>
          </div>
        )}
        <div className="nim-sessions">
          <div className="nim-sessions-scroll">
            <Scrollbar
              className="nim-scroll-bar"
              ref={(el) => (this.srcollElement = el)}
              onScroll={this.handleScroll}
            >
              {this.bindHtml()}
            </Scrollbar>
          </div>
        </div>

        {/* 通用弹窗 */}
        <IframeModal wrappedComponentRef={(el) => (this.iframeElement = el)} />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
